<div class="w-full px-6 py-8 space-y-10">
    <form [formGroup]="billingForm" (ngSubmit)="onSubmit()" class="p-4" class="space-y-10">
        <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
            <div class="flex items-center gap-2 border-b pb-2">
                <div class="w-[4px] h-6 bg-primary"></div>
                <h2 class="text-xl font-semibold text-gray-800">Monthly Billing</h2>
            </div>
            <div class="col-span-12">
                <mat-label>Module</mat-label>
                  <mat-form-field appearance="outline" class="w-full mb-4">
                <input matInput formControlName="module" />
            </mat-form-field>
            </div>
          

            <div formArrayName="features" class="mb-4">
                <label><strong>Features</strong></label>
                <div *ngFor="let feature of features.controls; let i = index">
                <div class="col-span-12">
                    <!-- <mat-label>{{ feature.get('label')?.value }} </mat-label> -->
                    <mat-form-field appearance="outline" class="w-full">
                        <input matInput [formControlName]="i" />
                    </mat-form-field>
                </div>
                </div>
            </div>

            <div formArrayName="forms" class="mb-4">
                <label><strong>Forms</strong></label>
                <div class="col-span-12">

                <div *ngFor="let form of forms.controls; let i = index">
                    <mat-form-field appearance="outline" class="w-full">
                        <input matInput [formControlName]="i" />
                    </mat-form-field>
                </div>
                </div>
            </div>

            <div formArrayName="systemAction" class="mb-4">
                <label><strong>System Action</strong></label>
                <div *ngFor="let action of systemAction.controls; let i = index">
                <div class="col-span-12">

                    <mat-form-field appearance="outline" class="w-full">
                        <input matInput [formControlName]="i" />
                    </mat-form-field>
                    </div>
                </div>
            </div>

            <div formArrayName="benefits" class="mb-4">
                <label><strong>Benefits</strong></label>
                <div *ngFor="let benefit of benefits.controls; let i = index">
                <div class="col-span-12">

                    <mat-form-field appearance="outline" class="w-full">
                        <input matInput [formControlName]="i" />
                    </mat-form-field>
                    </div>
                </div>
            </div>
                <div class="col-span-12">
                <mat-label>KPI</mat-label>

            <mat-form-field appearance="outline" class="w-full mb-4">
                <input matInput formControlName="kpi" />
            </mat-form-field>
            </div>

            <button mat-raised-button color="primary" type="submit">Submit</button>
        </div>
    </form>
</div>